module.exports = __webpack_public_path__ + "static/scale-model-of-athens-georgia-4501f3944de9e7f056e6bf2629bc5b58.png";